<template>
    <div class="m-progress-bar">
        <div class="m-progress-bar__bar" :style="'width: ' + calculateWidth() + '%;' + 'background: ' + completeColor() + ';'"></div>
    </div>
</template>

<script>

    export default {
        name: 'progress-bar',
        props: {
            value: {
                type: Number,
                default: 0
            },
            totalValue: {
                type: Number,
                default: 0
            }
        },
        data () {
            return {
                theWidth: this.value
            }
        },
        methods: {
            calculateWidth() {
                return this.value / this.totalValue * 100;
            },
            completeColor() {
                return this.value / this.totalValue * 100 == 100 ? '#67CFB6' : '#4A89E5';
            }
        }
    }
</script>



// WEBPACK FOOTER //
// ProgressBar.vue?02d06df3